import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

export const createJournalEntryReportOperation = async (
  entriesIds: number[],
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  // Mirror the backend Joi schema: entriesIds is required with min length of 1.
  if (!Array.isArray(entriesIds) || entriesIds.length === 0) {
    toast.warn('יש לבחור לפחות פקודת יומן אחת לדיווח');
    return;
  }

  try {
    setLoading(true);

    const res = await appApi.createJournalEntryReport({ entriesIds });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('הדיווח נוצר בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
